import { useEffect, useState } from "react";
import { Link, Outlet, useNavigate, NavLink } from "react-router-dom";
import { usePeticion, ESTADOS } from "../herramientas";
import { API_URL } from "../config";

export default function Index() {
  const nombreOperacion = "Exportar PDF de pedido";

  const [estado, setEstado] = useState(ESTADOS.CARGANDO);
  const [pedidos, setPedidos] = useState([]);
  const [pedidosFiltrados, setPedidosFiltrados] = useState([])
  const [filtroEstado, setFiltroEstado] = useState("todos")
  const [busqueda, setBusqueda] = useState("")

  const navigate = useNavigate();
  const peticion = usePeticion();

  useEffect(() => {
    peticion("z03/pedidos/", {})
      .then((json) => {
        setPedidos(json.pedidos)
        setPedidosFiltrados(json.pedidos)
        setEstado(ESTADOS.CARGADO)
      })
      .catch(e=>{
        alert("No han podido ser cargados los pedidos correctamente: "+e.message);
        setEstado(ESTADOS.CARGADO)
      })
  }, []);

  useEffect(()=>{
    let filtrado = pedidos.filter((fila)=>{
      let a, b;
      if (
        fila.nombre.toUpperCase().includes(busqueda.toUpperCase()) ||
        `${new Date(fila["fecha"]).getUTCDate()}/${new Date(fila["fecha"]).getUTCMonth() + 1}/${new Date(fila["fecha"]).getUTCFullYear()}`
          .toLocaleString()
          .includes(busqueda.toUpperCase()) ||
        fila.nombre_vendedor.toUpperCase().includes(busqueda.toUpperCase()) ||
        fila.dni.includes(busqueda) ||
        fila.telefono.includes(busqueda) ||
        fila.id_pedido.toString().includes(busqueda)
      ) {
        a = true;
      } else {
        a = false;
      }
      if (filtroEstado != "todos") {
        if (filtroEstado == fila.estado) {
          b = true
        } else {
          b = false
        }
      } else {
        b = true
      }
      return a && b
    })
    setPedidosFiltrados(filtrado)
  }, [busqueda, filtroEstado])

  let contenido;

  if (estado === ESTADOS.CARGANDO) {
    contenido = (
      <tr>
        <td colSpan="6">
          <div className="d-flex justify-content-center">
            <div className="spinner-border" role="status">
              <span className="visually-hidden">Loading...</span>
            </div>
          </div>
        </td>
      </tr>
    );
  } else if (estado === ESTADOS.CARGADO) {
    contenido = pedidosFiltrados.map((pedido) => (
      <tr>
        <td className="align-middle text-center">
          <a target="_blank" href={API_URL+"z03/pdf/" + pedido.id_pedido} role="button" className="btn btn-danger">
            PDF
          </a>
        </td>
        <td className="align-middle text-center">{pedido.id_pedido}</td>
        <td className="align-middle text-center">{`${new Date(pedido["fecha"]).getUTCDate()}/${new Date(pedido["fecha"]).getUTCMonth() + 1}/${new Date(
                    pedido["fecha"]
                  ).getUTCFullYear()}`}</td>
        <td className="align-middle text-center">{pedido.nombre}</td>
        <td className="align-middle text-center">{pedido.tipo_entrega}</td>
        <td className="align-middle text-center">{pedido.estado}</td>
      </tr>
    ));
  }

  return (
    <main className="container p-3">
      <h1>{nombreOperacion}</h1>
      <p>Seleccione el pedido que desea exportar.</p>
      <form>
        <div className="row g-3 mb-3">
          <div className="col-sm-8">
            <input type="text" placeholder="Buscar por número, vendedor, fecha, cliente, teléfono o DNI..." value={busqueda} onChange={(e)=>setBusqueda(e.target.value)} className="form-control" id="busqueda" />
          </div>
          <div className="col-sm-4">
            <select className="form-select" value={filtroEstado} onChange={(e)=>setFiltroEstado(e.target.value)} aria-label="Default select example">
              <option value="todos">Todos...</option>
              <option value="abierto">Abierto</option>
              <option value="completado">Completado</option>
              <option value="en transito">En transito</option>
            </select>
          </div>
        </div>
      </form>
      <div className="table-responsive">
        <table className="table table-striped table-hover table-bordered">
          <thead>
            <tr>
              <th className="align-middle text-center" scope="col">
                PDF
              </th>
              <th className="align-middle text-center" scope="col">
                Número
              </th>
              <th className="align-middle text-center" scope="col">
                Fecha
              </th>
              <th className="align-middle text-center" scope="col">
                Cliente
              </th>
              <th className="align-middle text-center" scope="col">
                Tipo de entrega
              </th>
              <th className="align-middle text-center" scope="col">
                Estado
              </th>
            </tr>
          </thead>
          <tbody id="tabla">{contenido}</tbody>
        </table>
      </div>
    </main>
  );
}
